/* ----------------------------------------------------------------
   Mirrors the live heysunday.com PDP buy box: a Subscribe and Save
   card and a One-time purchase card as two radios, scent inside each,
   frequency + quantity on the subscription, pack tiles on the one-time.
   Prices are the real Skio allocations: 30-day = 40% off, 60-day = 32%.
   ---------------------------------------------------------------- */
const PACKS = [
  {n:1,  once:25,  list:25 },
  {n:3,  once:60,  list:75 },
  {n:6,  once:114, list:150},
  {n:12, once:180, list:300}
];
const PLAN_OFF = {30:0.40, 60:0.32};
const BEST_VALUE = 12;                     // badge sits on the biggest pack
const SCENTS = [
  {name:'Ocean Breeze',   img:'ASSETS/pack-ocean-breeze.png'},
  {name:'Fragrance Free', img:'ASSETS/pack-fragrance-free.png'}
];
const A = k => (window.PDPV2 && window.PDPV2.assets && window.PDPV2.assets[k.replace('ASSETS/','')]) || k;
/* Slide 1 is the dissolve demo. "Does one thin sheet actually clean?" is a
   visceral objection and text does not answer it — the same store video the
   live PDP already uses. Everything else is a still. */
const HERO_VIDEO = {
  video:  'https://cdn.shopify.com/videos/c/o/v/ecef071960e841ca82b6a1c988577d23.mp4',
  poster: 'https://store.heysunday.com/cdn/shop/files/preview_images/5c028a8c60904493832e8ecc0d874c7e.thumbnail.0000000000_800x.jpg?v=1713965205',
  alt:    'A HeySunday sheet dissolving in the drum'
};
/* The shared slides. The chosen scent's pack is pushed in front of these, so
   slide 1 always shows what you actually selected — the single most-cited PDP
   rule: the image must update when the variant does. */
const SHARED = ['ASSETS/pack-benefits.jpg','ASSETS/pack-angled.jpg','ASSETS/pack-closeup.jpg','ASSETS/sheets-stack.jpg','ASSETS/how-much-to-use.jpg','ASSETS/pack-detail.jpg'];
let GALLERY = [];

let mode = 'sub', scent = 0, pack = 0, qty = 1, gi = 0;

const money = n => '$' + (Number.isInteger(n) ? n : n.toFixed(2));
const subPrice = () => +(PACKS[0].once * (1 - PLAN_OFF[document.getElementById('freq').value]) * qty).toFixed(2);
/* The control's default offer: +15% off the FIRST subscription order via the
   "Extra Discount" code. It is a code, not an automatic — if the page does not
   apply it the shopper is charged the undiscounted price at checkout. */
const COUPON_OFF = 0.15;
const couponOn = () => { const b = document.getElementById('couponBox'); return !!(b && b.checked); };
const firstCyclePrice = () => +(subPrice() * (1 - COUPON_OFF)).toFixed(2);

/* ---------------- gallery ---------------- */
const thumbs = document.getElementById('thumbs');
const isVideo = s => typeof s === 'object' && !!s.video;

function buildGallery(keepIndex){
  GALLERY = [SCENTS[scent].img].concat(SHARED);
  thumbs.innerHTML = '';
  GALLERY.forEach((src,i)=>{
    const b = document.createElement('button');
    b.type = 'button';
    b.innerHTML = isVideo(src)
      ? '<img src="'+src.poster+'" alt=""><span class="thumb-play" aria-hidden="true">\u25B6</span>'
      : '<img src="'+A(src)+'" alt="">';
    if (isVideo(src)) b.classList.add('is-video');
    b.setAttribute('aria-label', isVideo(src) ? 'Play the video' : 'View image '+(i+1));
    b.onclick = () => setGal(i);
    thumbs.appendChild(b);
  });
  setGal(typeof keepIndex === 'number' ? keepIndex : 0);
}
function setGal(i){
  gi = (i + GALLERY.length) % GALLERY.length;
  const src = GALLERY[gi];
  const stage = document.getElementById('galStage');
  if (isVideo(src)) {
    stage.innerHTML = '<video id="galVid" playsinline muted loop autoplay preload="metadata" ' +
      'poster="'+src.poster+'" src="'+src.video+'" aria-label="'+src.alt+'"></video>';
    const v = document.getElementById('galVid');
    if (v) { const p = v.play(); if (p && p.catch) p.catch(()=>{}); }
  } else {
    stage.innerHTML = '<img id="galImg" src="'+A(src)+'" alt="HeySunday laundry detergent sheets">';
  }
  [...thumbs.children].forEach((b,n)=>b.setAttribute('aria-current', n===gi));
}
const galStep = d => setGal(gi + d);
buildGallery(0);

/* Swipe the gallery — the gesture mobile shoppers reach for first. */
(() => {
  const el = document.querySelector('.gal-main');
  let x0 = null, y0 = null;
  el.addEventListener('touchstart', e => {
    x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
  }, {passive:true});
  el.addEventListener('touchend', e => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    const dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galStep(dx < 0 ? 1 : -1);
    x0 = null;
  }, {passive:true});
})();

/* ---------------- scent radios (one set per card) ---------------- */
['subScents','onceScents'].forEach(id=>{
  const wrap = document.getElementById(id);
  SCENTS.forEach((s,i)=>{
    const b = document.createElement('button');
    b.className = 'scent-opt';
    b.type = 'button';                     /* not a submit — it sits inside the product form */
    b.setAttribute('role','radio');
    b.innerHTML = '<span class="swatch" style="background-image:url('+A(s.img)+')"></span>'+s.name;
    /* rebuild so slide 1 is the pack you just chose, and jump to it */
    b.onclick = e => {
      e.stopPropagation();
      scent = i;
      buildGallery(0);
      render();
    };
    wrap.appendChild(b);
  });
});

/* ---------------- pack tiles (one-time) ---------------- */
const packsEl = document.getElementById('packs');
function buildPackTiles(){
  packsEl.innerHTML = '';
  PACKS.forEach((p,i)=>{
    const b = document.createElement('button');
    b.className = 'pack';
    b.type = 'button';                     /* not a submit — it sits inside the product form */
    b.setAttribute('role','radio');
    b.innerHTML = (p.n === BEST_VALUE ? '<span class="bv">BEST VALUE</span>' : '')+
      '<div class="n">'+p.n+' Pack</div><div class="p">'+money(p.once)+'</div>';
    b.onclick = e => { e.stopPropagation(); pack = i; render(); };
    packsEl.appendChild(b);
  });
}
buildPackTiles();

function setMode(m){ mode = m; render(); }
function qtyBump(d){ qty = Math.max(1, qty + d); render(); }

/* the drag-compare slider was replaced by a static two-up */

/* Section videos: preload nothing until they are near the viewport, then play
   while visible and pause when not. Same pattern as the offer-39 base. */
(() => {
  const vids = [...document.querySelectorAll('.zig-vid')];
  if (!vids.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting) {
      if (v.preload === 'none') v.preload = 'auto';
      const p = v.play(); if (p && p.catch) p.catch(() => {});
    } else { try { v.pause(); } catch (x) {} }
  }), {threshold: 0.25});
  vids.forEach(v => io.observe(v));
})();

/* ---------------- render ---------------- */
function render(){
  const sub = mode === 'sub';
  document.getElementById('optSub').setAttribute('aria-checked', sub);
  document.getElementById('optOnce').setAttribute('aria-checked', !sub);

  /* The subscription always sells the 1-pack variant by quantity, matching the
     live PDP. So the subscribe card always prices THAT — including while it is
     collapsed. Previewing the selected pack size here advertised a price
     (e.g. $108 for the 12-pack) that nothing in the flow can buy. */
  const p = PACKS[pack];
  const useCoupon = couponOn();
  document.getElementById('subNow').textContent =
    money(useCoupon ? firstCyclePrice() : subPrice());
  document.getElementById('subWas').textContent = money(PACKS[0].list * qty);
  const fc = document.getElementById('firstCycle');
  if (fc) {
    fc.textContent = 'for the first cycle, then ' + money(subPrice()) + '/pack on every order';
    fc.style.display = useCoupon ? '' : 'none';
  }
  document.getElementById('qtyVal').textContent = qty;
  document.getElementById('onceNow').textContent = money(p.once);

  document.querySelectorAll('.scents').forEach(w=>{
    [...w.children].forEach((b,i)=>b.setAttribute('aria-checked', i === scent));
  });
  packsEl.querySelectorAll('.pack').forEach((b,i)=>b.setAttribute('aria-checked', i === pack));

  const t = sub
    ? {label:'Subscribe & Save', price: couponOn() ? firstCyclePrice() : subPrice(), packs:qty}
    : {label:'One-time', price:PACKS[pack].once, packs:PACKS[pack].n};
  document.getElementById('sbTitle').textContent =
    t.packs + (t.packs > 1 ? ' packs' : ' pack') + ' · ' + SCENTS[scent].name;
  document.getElementById('sbPrice').textContent =
    money(t.price) + ' · ' + t.label;
  /* the bar used to say "Add to cart" while the selection was a subscription */
  document.getElementById('ctaSticky').textContent = sub ? 'Subscribe & Save' : 'Add to Cart';

}


/* ============================================================
   Shopify cart wiring — the house pattern from 03_Build_Playbook:
   /cart/add.js  ->  /discount/<code>  ->  /cart/update.js (sections)
   ->  open the theme cart drawer, hard fallback /cart.

   Native <product-form> submits fail silently on page templates, so
   there is deliberately no form element here.

   Variant and selling-plan IDs are read at runtime from
   /products/<handle>.js — the only surface exposing
   selling_plan_allocations on a page template. The hardcoded map is a
   fallback; it was correct on 2026-08-14.
   ============================================================ */
const FALLBACK_VARIANTS = {
  'Ocean Breeze':   {1:44406385246495, 3:48578618294559, 6:48578618327327, 12:48578618360095},
  'Fragrance Free': {1:44406385279263, 3:48578618392863, 6:48578618425631, 12:48578618458399}
};
const FALLBACK_PLANS = {30:8589246751, 60:8682897695};   // 40% off / 32% off

/* The live PDP's donation product (10573362921759) and the destination it
   adds — its first variant. The old ECCO variant 52639646023967 belongs to a
   retired product. Swapping charity in future = change this ID only; the page
   copy deliberately never names one. */
const DONATION_VARIANT = 52772460101919;
const DONATION_QTY     = 5;
const DONATION_CODE    = 'First 5 donated loads on us!';
const COUPON_CODE      = 'Extra Discount';

let VARIANTS = JSON.parse(JSON.stringify(FALLBACK_VARIANTS));
let SELLING_PLANS = Object.assign({}, FALLBACK_PLANS);

(function loadLiveProduct(){
  const handle = (window.PDPV2 && window.PDPV2.handle) || 'laundry-sheets';
  fetch('/products/' + handle + '.js', {headers:{'Accept':'application/json'}})
    .then(r => { if (!r.ok) throw new Error('product.js ' + r.status); return r.json(); })
    .then(p => {
      const variants = {}, plans = {};
      p.variants.forEach(v => {
        const opts = (v.options || []).concat([v.title || '']);
        const scentName = SCENTS.map(s => s.name)
          .find(n => opts.some(o => String(o).toLowerCase().includes(n.toLowerCase())));
        const packOpt = opts.map(o => String(o).match(/(\d+)\s*pack/i)).find(Boolean);
        const packN = packOpt ? parseInt(packOpt[1], 10) : null;
        if (!scentName || !packN) return;
        variants[scentName] = variants[scentName] || {};
        variants[scentName][packN] = v.id;

        const row = PACKS.find(x => x.n === packN);
        if (row) {
          row.once = v.price / 100;
          if (v.compare_at_price && v.compare_at_price > v.price) row.list = v.compare_at_price / 100;
        }

        (v.selling_plan_allocations || []).forEach(spa => {
          const group = (p.selling_plan_groups || [])
            .find(g => (g.selling_plans || []).some(sp => sp.id === spa.selling_plan_id));
          const plan = group && group.selling_plans.find(sp => sp.id === spa.selling_plan_id);
          const days = plan && String(plan.name).match(/(\d+)\s*day/i);
          if (days) plans[days[1]] = spa.selling_plan_id;
        });
      });
      const complete = SCENTS.every(s => variants[s.name] && PACKS.every(x => variants[s.name][x.n]));
      if (complete) VARIANTS = variants;
      if (plans[30] && plans[60]) SELLING_PLANS = plans;
      buildPackTiles();
      render();
    })
    .catch(err => {
      console.warn('[pdp-v2] live product fetch failed, using 2026-08-14 fallback IDs', err);
    });
})();

function currentLine(){
  const scentName = SCENTS[scent].name;
  if (mode === 'sub'){
    const freq = document.getElementById('freq').value;
    return {id: VARIANTS[scentName][1], quantity: qty, selling_plan: SELLING_PLANS[freq]};
  }
  return {id: VARIANTS[scentName][PACKS[pack].n], quantity: 1};
}

function openDrawer(res){
  try {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { location.href = '/cart'; return; }
    drawer.classList.remove('is-empty');
    if (res && res.sections) {
      const dh = res.sections['cart-drawer'];
      if (dh) {
        const tmp = document.createElement('div');
        tmp.innerHTML = dh;
        const ni = tmp.querySelector('.drawer__inner');
        const ci = drawer.querySelector('.drawer__inner');
        if (ni && ci) ci.innerHTML = ni.innerHTML;
      }
      const bh = res.sections['cart-icon-bubble'];
      if (bh) {
        const bb = document.querySelector('#cart-icon-bubble');
        if (bb) {
          const t2 = document.createElement('div');
          t2.innerHTML = bh;
          bb.innerHTML = (t2.firstElementChild || t2).innerHTML;
        }
      }
    }
    if (typeof drawer.open === 'function') drawer.open();
    else location.href = '/cart';
  } catch (e) {
    location.href = '/cart';
  }
}

/* How many donation loads still need adding to reach DONATION_QTY.
   `First 5 donated loads on us!` is a FIXED $1.25 off the donate-a-load
   collection, not "first five free" — so blindly adding 5 on every
   add-to-cart charges the shopper $1.25 for the second five. Top up to 5,
   never past it. */
function donationTopUp(){
  return fetch('/cart.js', {headers:{'Accept':'application/json'}})
    .then(r => r.ok ? r.json() : null)
    .then(c => {
      if (!c || !c.items) return DONATION_QTY;
      const have = c.items
        .filter(i => i.variant_id === DONATION_VARIANT)
        .reduce((n, i) => n + i.quantity, 0);
      return Math.max(0, DONATION_QTY - have);
    })
    .catch(() => DONATION_QTY);
}

function addToCart(btn){
  const line = currentLine();
  if (!line.id) { location.href = '/products/laundry-sheets'; return; }
  const label = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  donationTopUp().then(function(need){
  const items = need > 0 ? [line, {id: DONATION_VARIANT, quantity: need}] : [line];

  return fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest'},
    body: JSON.stringify({items: items})
  })
  .then(r => { if (!r.ok) throw new Error('cart/add ' + r.status); return r; })
  .then(() => fetch('/discount/' + encodeURIComponent(DONATION_CODE), {redirect:'manual'}).catch(()=>{}))
  /* "Extra Discount" is a CODE, not an automatic. The control applies it on
     add; if we show $12.75 without applying it, checkout charges $15. */
  .then(() => (mode === 'sub' && couponOn())
    ? fetch('/discount/' + encodeURIComponent(COUPON_CODE), {redirect:'manual'}).catch(()=>{})
    : null)
  .then(() => fetch('/cart/update.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({updates:{}, sections:['cart-drawer','cart-icon-bubble']})
  }).then(r => r.json()))
  .then(res => { openDrawer(res); if (btn) { btn.disabled = false; btn.textContent = label; } });
  })
  .catch(err => {
    console.error('[pdp-v2] add to cart failed', err, line);
    if (btn) { btn.disabled = false; btn.textContent = label; }
    location.href = '/cart';
  });
}

['ctaSub','ctaOnce','ctaSticky'].forEach(id => {
  const el = document.getElementById(id);
  if (el) el.addEventListener('click', e => { e.stopPropagation(); addToCart(el); });
});

render();
